module.exports = "<jhi-button\n    icon=\"fa-arrow-circle-right\"\n    [isLoading]=\"isLoading\"\n    [isDisabled]=\"isLoading || isDisabled\"\n    iconRight\n    (onClick)=\"onClickButton()\">\n    {{ label ? label : 'Suivant' }}\n    <ng-content></ng-content>\n</jhi-button>\n"


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/app/shared/components/forms/button/next-button/next-button.component.html
// module id = 842
// module chunks = 0